import { Flex, Link, Text } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./AiPolicyTabAgentAiDiscoveryDrawer.module.scss"

import type { PolicyRecordInput } from "@/pages/GovernancePage/applications/policies/useAiPolicies.types"

// The drawer's policy header: what applies to this agent and where it comes from.
export const EffectivePolicyHeader = (props: { record: PolicyRecordInput }) => {
  const { record } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.harden.effective"
  })
  const { ROOT, AI } = NAMES_ROUTES.GOVERNANCE
  const isOwn = record.type === "agent"

  return (
    <Flex vertical gap={2}>
      <Text className={styles.effectiveTitle}>{t("title")}</Text>
      <Flex align="center" gap={4}>
        <Text className={styles.effectiveMuted}>
          {t(isOwn ? "own" : "inheritedFrom")}
        </Text>
        <Link type="link" to={`/${ROOT}/${AI}/${record.id}/view`}>
          {isOwn ? record.policyName : record.name}
        </Link>
      </Flex>
    </Flex>
  )
}
